export default __webpack_public_path__ + "static/media/maintenance.350a6717.svg";